export const passwordConditions = [
  {
    id: 1,
    name: "At least 8 characters - the more characters the better.",
  },
  {
    id: 2,
    name: "A mixture of upper and lower case letters.",
  },
  { id: 3, name: "A mixture of letters and numbers." },
  {
    id: 4,
    name: "At least one special character, e.g. ! @ # ? ]",
  },
];

export const yourAssetsLinks = [
  {
    id: 1,
    name: "Family Tree",
    to: "family-tree",
    route: "/your-assets/family-tree",
  },
  {
    id: 2,
    name: "Assets",
    to: "balance-of-assets",
    route: "/your-assets/balance-of-assets",
  },
  {
    id: 3,
    name: "Shares of inheritance",
    to: "shares-of-inheritance",
    route: "/your-assets/shares-of-inheritance",
  },
];
export const yourWishesLinks = [
  {
    id: 1,
    name: "Status Quo",
    to: "status-quo",
    route: "/your-wishes/status-quo",
  },
  {
    id: 2,
    name: "Your Wishes",
    to: "your-wishes",
    route: "/your-wishes/your-wishes",
  },
];
export const documentsLinks = [
  {
    id: 1,
    name: "Healthcare proxy",
    to: "healthcare-proxy",
    route: "/documents/healthcare-proxy",
    title: "Healthcare Proxy",
  },
  {
    id: 2,
    name: "Guardianship ordinance",
    to: "guardianship-ordinance",
    route: "/documents/guardianship-ordinance",
    title: "Guardianship Ordinance",
  },
  {
    id: 3,
    name: "Organ donation",
    to: "organ-donation",
    route: "/documents/organ-donation",
    title: "Organ Donation Document",
  },
  {
    id: 4,
    name: "Custody order",
    to: "custody-order",
    route: "/documents/custody-order",
    title: "Custody Order",
  },
  {
    id: 5,
    name: "Care directive",
    to: "care-directive",
    route: "/documents/care-directive",
    title: "Care Directive",
  },
];

export const CasesFcDomainsLinks = [
  {
    id: 1,
    name: "Family Tree",
    to: "/family-tree",
    route: "family-tree",
    aduitTrailKey: ["Family Tree"],
  },

  {
    id: 2,
    name: "Assets",
    to: "/assets",
    route: "assets",
    aduitTrailKey: ["Assets"],
  },
  {
    id: 3,
    name: "Shares of Inheritance",
    to: "/shares-of-inheritance",
    route: "shares-of-inheritance",
    aduitTrailKey: ["Shares of Inheritance"],
  },
  {
    id: 4,
    name: "Total assets Value",
    to: "/total-assets-value",
    route: "total-assets-value",
    aduitTrailKey: ["Total assets Value"],
  },
  {
    id: 5,
    name: "Donations",
    to: "/donations",
    route: "donations",
    aduitTrailKey: ["Donations"],
  },
  {
    id: 6,
    name: "Documents",
    to: "/documents",
    route: "documents",
    aduitTrailKey: ["Documents"],
  },
  {
    id: 7,
    name: "Report",
    to: "/report",
    route: "report",
    aduitTrailKey: ["Reports"],
  },
  {
    id: 8,
    name: "Uploaded Documents",
    to: "/uploaded-documents",
    route: "uploaded-documents",
    aduitTrailKey: ["Uploaded documents boa", "Uploaded documents statusquo"],
  },
];

export const codeBoxes = [1, 2, 3, 4, 5, 6];

export const members = [
  {
    id: 1,
    name: "Bernd König",
    image: "/assets/images/members/Bernd König.png",
    comment:
      "Mir ist als Generationenberater bzw. Estate Planner wichtig, bei unseren Kunden die besonderen Erfordernisse innerhalb familiärer Strukturen zu verstehen und aufgrund meiner Fachkompetenz wertvolle Anregungen und Ratschläge geben zu können.",
    roles: [
      { id: 1, name: "Financial Planner (Frankfurt School)" },
      { id: 2, name: "Estate Planner (EBS)" },
      { id: 3, name: "zertifizierter Testamentsvollstrecker (EBS)" },
    ],
  },
  {
    id: 2,
    name: "Vanessa Halama",
    image: "/assets/images/members/Vanessa Halama.png",
    comment:
      "„Das Gefühl den Kundinnen und Kunden tatsächlich geholfen und ihnen viele Sorgen vor der Zukunft genommen zu haben ist es, was diesen Job so besonders macht. Meine Arbeit ist nicht nur wichtig, sondern auch sinnstiftend und das erfüllt mich.“",
    roles: [{ id: 1, name: "zertifizierter Estate Planner (ADG)" }],
  },
  {
    id: 3,
    name: "Sandra Foltin",
    image: "/assets/images/members/Sandra Foltin.png",
    comment: "",
    roles: [
      { id: 1, name: "Financial Planner (HfB)" },
      { id: 2, name: "Zertifizierter Estate Planner (ADG)" },
      { id: 3, name: "Certified Estate Planner (CEP)" },
      { id: 4, name: "Zertifizierte Testamentsvollstreckerin" },
    ],
  },
  {
    id: 4,
    name: "Mona Adam",
    image: "/assets/images/members/Mona Adam.png",
    comment:
      "„Krankheit und Tod sind für uns Menschen häufig sehr belastende Themen, die wir am liebsten aus unseren Gesprächen und Gedanken ausklammern. Und doch werden wir immer wieder damit konfrontiert, ob wir wollen oder nicht. In Zeiten starker Belastung durch Krankheit oder als Folge eines Todesfalls, müssen Regelungen getroffen werde, für diese eigentlich keine Kraft geschweige denn das nötige Knowhow vorhanden sind. Menschen durch frühzeitige Vorsorgeplanung genau hiervor zu bewahren, vollumfänglich zu beraten und zu begleiten ist für mich der tägliche Antrieb für meine Arbeit.“",
    roles: [
      { id: 1, name: "Estate Planner (ADG)" },
      { id: 2, name: "Zertifizierte Testamentsvollstreckerin" },
    ],
  },
  {
    id: 5,
    name: "Kim Kallfass",
    image: "/assets/images/members/Kim Kallfass.png",
    comment:
      "Mir persönlich ist es wichtig, dass unsere Kunden Zeit mit der Familie und Freunden verbringen können, ohne sich Sorgen über die Zukunft machen zu müssen. Unsere Generationenberatung sorgt dafür, dass in Ihrer Familie auch im Unglücksfall nichts ins Rutschen kommt.",
    roles: [
      { id: 1, name: "zertifizierter Senior Estate Planner (ADG)" },
      { id: 2, name: "zertifizierter Stiftungsberater (ADG)" },
      {
        id: 3,
        name: "zertifizierter Testamentsvollstrecker (Weinsberger Forum)",
      },
    ],
  },
  {
    id: 6,
    name: "Robin Weimann",
    image: "/assets/images/members/Robin Weimann.png",
    comment:
      "Ich kann meinen Kunden ein gutes Gefühl geben alles geregelt zu haben und ich erhalte sehr viel Dankbarkeit von meinen Kunden“",
    roles: [
      { id: 1, name: "zertifizierter Senior Estate Planner" },
      { id: 2, name: "zertifizierter Testamentsvollstrecker" },
      { id: 3, name: "Mediator" },
      { id: 4, name: "Stiftungsmanager" },
    ],
  },
  {
    id: 7,
    name: "Dorit Stumpe",
    image: "",
    comment:
      "„Die Familie ist der größte emotionale Treiber und steht im Mittelpunkt einer Generationenberatung. Aufzuzeigen was passiert, wenn nichts geregelt ist, ist",
    roles: [{ id: 1, name: "Zertifizierter Estate Planner (ADG)" }],
  },
];

export const boaRealEstateTypes = [
  {
    id: 1,
    name: "Apartment",
    key: "apartment",
    count: 0,
    data: [],
  },
  {
    id: 2,
    name: "Single-family house",
    key: "singleFamilyHouse",
    count: 0,
    data: [],
  },
  {
    id: 3,
    name: "Multi-family house",
    key: "multiFamilyHouse",
    count: 0,
    data: [],
  },
  { id: 4, name: "Vacation home", key: "vacationHome", count: 0, data: [] },
  {
    id: 5,
    name: "Family residential home",
    key: "familyResidentialHome",
    count: 0,
    data: [],
  },
  {
    id: 6,
    name: "Real estate used by third parties",
    key: "realEstateUsedByThirdParties",
    count: 0,
    data: [],
  },
  { id: 7, name: "Forests", key: "forests", count: 0, data: [] },
  {
    id: 8,
    name: "Agriculturual land",
    key: "agriculturualLand",
    count: 0,
    data: [],
  },
  {
    id: 9,
    name: "Construction sites",
    key: "constructionSites",
    count: 0,
    data: [],
  },
];

export const balanceOfAssetsLinks = [
  {
    id: 1,
    name: "Real Estate",
    image: "/assets/icons/real-estate.png",
    multipleSteps: true,
  },
  {
    id: 2,
    name: "Bank Balances",
    image: "/assets/icons/bank-balances.png",

    multipleSteps: false,
  },
  {
    id: 3,
    name: "Securities",
    image: "/assets/icons/securities.png",

    multipleSteps: false,
  },
  {
    id: 4,
    name: "Insurances",
    image: "/assets/icons/insurances.png",

    multipleSteps: true,
  },
  {
    id: 5,
    name: "Gold/Raw Materials",
    image: "/assets/icons/gold-raw-materials.png",

    multipleSteps: true,
  },
  {
    id: 6,
    name: "Shareholdings",
    image: "/assets/icons/share-holdings.png",

    multipleSteps: false,
  },
  {
    id: 7,
    name: "Corporate Shareholdings",
    image: "/assets/icons/co-share-holdings.png",

    multipleSteps: false,
  },
  {
    id: 8,
    name: "Others",
    image: "",

    multipleSteps: false,
  },
];

export const documentSteps = [
  {
    id: 1,
    name: "Get started",
    image: "/assets/icons/real-estate.png",
    multipleSteps: false,
  },
  {
    id: 2,
    name: "Attorney",
    image: "/assets/icons/bank-balances.png",

    multipleSteps: false,
  },
  {
    id: 3,
    name: "Checklist",
    image: "/assets/icons/securities.png",

    multipleSteps: false,
  },
  {
    id: 4,
    name: "",
    image: "/assets/icons/insurances.png",

    multipleSteps: false,
  },
  {
    id: 5,
    name: "",
    image: "/assets/icons/gold-raw-materials.png",

    multipleSteps: false,
  },
  {
    id: 6,
    name: "",
    image: "/assets/icons/share-holdings.png",

    multipleSteps: false,
  },
  {
    id: 7,
    name: "",
    image: "/assets/icons/co-share-holdings.png",

    multipleSteps: false,
  },

  {
    id: 8,
    name: "Emergency folder",
    image: "",

    multipleSteps: false,
  },
  {
    id: 9,
    name: "Signature",
    image: "",

    multipleSteps: false,
  },
  {
    id: 10,
    name: "Overview",
    image: "",

    multipleSteps: false,
  },
];
export const guardianshipSteps = [
  {
    id: 1,
    name: "Get started",
    image: "/assets/icons/real-estate.png",
    multipleSteps: false,
  },
  {
    id: 2,
    name: "Guardian",
    image: "/assets/icons/bank-balances.png",
    multipleSteps: false,
  },
  {
    id: 3,
    name: "Wishes",
    image: "/assets/icons/securities.png",

    multipleSteps: false,
  },
  {
    id: 4,
    name: "Emergency Folder",
    image: "/assets/icons/insurances.png",

    multipleSteps: false,
  },
  {
    id: 5,
    name: "Signature",
    image: "/assets/icons/gold-raw-materials.png",

    multipleSteps: false,
  },
  {
    id: 6,
    name: "Overview",
    image: "",

    multipleSteps: false,
  },
];
export const careDirectiveSteps = [
  {
    id: 1,
    name: "Get started",
    image: "/assets/icons/real-estate.png",
    multipleSteps: false,
  },
  {
    id: 2,
    name: "Food/Drinks",
    image: "/assets/icons/bank-balances.png",
    multipleSteps: false,
  },
  {
    id: 3,
    name: "Clothing",
    image: "/assets/icons/securities.png",

    multipleSteps: false,
  },
  {
    id: 4,
    name: "Bodycare",
    image: "/assets/icons/insurances.png",

    multipleSteps: false,
  },
  {
    id: 5,
    name: "Other",
    image: "/assets/icons/gold-raw-materials.png",

    multipleSteps: false,
  },
  {
    id: 6,
    name: "Individual wishes",
    image: "",

    multipleSteps: false,
  },
  {
    id: 7,
    name: "Overview",
    image: "",

    multipleSteps: false,
  },
];
export const organDonation = [
  {
    id: 1,
    name: "Get started",
    image: "/assets/icons/real-estate.png",
    multipleSteps: false,
  },
  {
    id: 2,
    name: "Declaration",
    image: "/assets/icons/bank-balances.png",
    multipleSteps: false,
  },
  {
    id: 3,
    name: "Overview",
    image: "/assets/icons/securities.png",

    multipleSteps: false,
  },
];
export const propertyCurrentStatus = [
  {
    id: 1,
    name: "My Self",
    image: "/assets/icons/partner-male.png",
  },
  {
    id: 2,
    name: "Kids",
    image: "/assets/icons/child-male.png",
  },
  {
    id: 3,
    name: "Renting",
    image: "/assets/icons/rent.png",
  },
  {
    id: 4,
    name: "Grand Kids",
    image: "/assets/icons/child-male.png",
  },
];

export const familyMembers = [
  {
    id: 1,
    name: "Partner",
    images: [
      { id: 2, image: "partner-female.png" },
      { id: 1, image: "partner-male.png" },
    ],
  },
  {
    id: 2,
    name: "Ex-Partner",
    images: [
      { id: 4, image: "ex-partner-female.png" },
      { id: 3, image: "ex-partner-male.png" },
    ],
  },
  {
    id: 3,
    name: "Parents",
    images: [
      { id: 6, image: "parent-female.png" },
      { id: 5, image: "parent-male.png" },
    ],
  },
  {
    id: 4,
    name: "Child",
    images: [
      { id: 10, image: "child-female.png" },
      { id: 9, image: "child-male.png" },
    ],
  },
  {
    id: 5,
    name: "Siblings",
    images: [
      { id: 8, image: "sibling-female.png" },
      { id: 7, image: "sibling-male.png" },
    ],
  },
  {
    id: 6,
    name: "Others",
    images: [
      { id: 11, image: "pet.png" },
      { id: 12, image: "friend.png" },
    ],
  },
];

export const chartOptions = [
  {
    role: "Partner",
    color: "#444561",
    series: 44,
  },

  {
    role: "Child 1",
    color: "#6b607e",
    series: 55,
  },

  {
    role: "Child 2",
    color: "#957ba0",
    series: 41,
  },

  {
    role: "Kind 1",
    color: "#c298bb",
    series: 17,
  },
];
export const propertyInsurances = [
  { name: "Liability insurance", id: 1 },
  { name: "Household insurance", id: 2 },
  { name: "Homeowners insurance", id: 3 },
  { name: "legal expenses insurance", id: 4 },
];
export const personalInsurances = [
  { name: "term life insurance", id: 5 },
  { name: "company pension plan", id: 6 },
  { name: "Endowment insurance (with annuity)", id: 7 },
  { name: "accident insurance (with premium refund)", id: 8 },
];
export const relationships = [
  { id: 1, name: "Partner-Male", gender: "male" },
  { id: 2, name: "Partner-Female", gender: "female" },
  { id: 3, name: "Ex-Partner-Male", gender: "male" },
  { id: 4, name: "Ex-Partner-Female", gender: "female" },
  { id: 5, name: "Father", gender: "male" },
  { id: 6, name: "Mother", gender: "female" },
  { id: 7, name: "Brother", gender: "male" },
  { id: 8, name: "Sister", gender: "female" },
  { id: 9, name: "Son", gender: "male" },
  { id: 10, name: "Daughter", gender: "female" },
  { id: 11, name: "Pet", gender: "male" },
  { id: 12, name: "Friend", gender: "male" },
];

export const goldRawMaterials = [
  { name: "Gold", id: 1 },
  { name: "Silver", id: 2 },
  { name: "Bronze", id: 3 },
  { name: "Palladium", id: 4 },
  { name: "Coins", id: 5 },
  { name: "Other", id: 6 },
  { name: "Platinum", id: 7 },
];

export const QuestionByCategoryType = {
  MEDICAL_CARE: 1,
  RESIDENCE_AND_HOUSING: 2,
  AUTHORITIES: 3,
  ASSET_MANAGEMENT: 4,
  MAIL_TELE_COMUNICATION: 5,
  INSIDE_BUSINESS: 6,
  COURT_REPRESENTATION: 7,
  SUB_AUTHORITIES: 8,
  GUARDIAN_ORDIANCE: 9,
  VALIDITY_BEYOND_DEATH: 10,
  ACCOUNTABLITIY: 11,
  ConsantRepresentation: 12, 
};

export const allowedUsers = ["#EU", "#EC"];

// constants of assets for audit trail
export const assetStepsNames = [
  "RealEstate",
  "BankAccount",
  "Security",
  "Insurance",
  "Material",
  "Shareholding",
  "CorporateShareholding",
  "Loan",
  "OtherHolding",
  "Donation",
];
export const uploadedDocumentsAuditsNames = ["statusquomedia", "boausermedia"];
// constants for statusquo healthcare proxy for audit trail
export const healthcareAuditSteps = [
  "attorneydetail",
  "donordetail",
  "furtherregulation",
  "healthproxy",
  "healthproxyanswer",
  "healthproxyemergency",
  "replacementattorney",
];

// constants for statusquo care directive for audit trail
export const careDirectiveAuditSteps = [
  "bodycare",
  "caredirective",
  "cloth",
  "fooddrink",
  "othercaredirective",
];

// constants for guardian ordinance for audit trail
export const guardianOrdinanceAuditSteps = [
  "guardianbynomean",
  "guardiandeterminedetail",
  "guardianemergency",
  "guardianordinance",
  "guardianwish",
  "primaryguardian",
  "secondaryguardian",
];

// constants for organ donation for audit trail

export const organDonationAuditSteps = [
  "organdonation",
  "organdonationauthorizeperson",
  "organdonationpersondetail",
];
export const custodyOrderAuditSteps = ["custodyOrder"];

// not navigate documents with these statuses
export const documentStatusesNotToNavigate = [
  "not uploaded",
  "uploaded",
  "not selected",
];

//Parent routes of app
export const parentRoutes = {
  assets: "/your-assets",
  your_wishes: "/your-wishes",
  documents: "/documents",
  appointments: "/appointment",
  cases: "/cases",
  appointments: "/appointments",
};

export const permissionsForEU = {
  familyTree: "#manageFemilyTree",
  totalAssetValue: "#manageTotalAssetsValue",
  appointments: "#manageAppointments",
  yourWishes: "#manageStatusQuo",
  assets: "#manageBalanceOfAssets",
  shareOfInheritance: "#manageShareOfInheritance",
};
export const permissionsForEC = {
  assets: "#manageBalanceOfAssets",
  cases: "#manageCases",
  uploadedDocuments: "#manageUploadedDocumets",
  totalAssetsValue: "#manageTotalAssetsValue",
  documents: "#manageStatusQuo",
  sharesOfInheritance: "#manageShareOfInheritance",
  familyTree: "#manageFemilyTree",
  appointments: "#manageAppointments",
  report: "#manageReports",
};
export const getAge = (selectedDate) => {
  if (!selectedDate) {
    return -1;
  }

  const today = new Date();
  const dob = new Date(selectedDate);

  let age = today.getFullYear() - dob.getFullYear();

  if (
    today.getMonth() < dob.getMonth() ||
    (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
  ) {
    age--;
  } else if (
    today.getMonth() === dob.getMonth() &&
    today.getDate() === dob.getDate()
  ) {
    return age;
  }

  console.log("Age:", age); // Logging the calculated age

  return age;
};

// export const getAge = (dobFormated) => {
//   dobFormated = dobFormated.toString();
//   let dob = dobFormated.split("-").join("");
//   let year = Number(dob.substr(0, 4));
//   let month = String(dob.substr(4, 2)) - 1;
//   let day = Number(dob.substr(6, 2));
//   let today = new Date();
//   let age = today.getFullYear() - year;
//   if (
//     today.getMonth() < month ||
//     (today.getMonth() == month && today.getDate() < day)
//   ) {
//     age--;
//   }
//   return age;
// };
// export const getAge = (dobFormatted) => {
//   // Check if dobFormatted is a non-empty string
//   if (typeof dobFormatted !== 'string' || dobFormatted.length !== 10) {
//     return null; // Return null or an appropriate value for invalid input
//   }

//   const dob = dobFormatted.split("-").join("");
//   const year = Number(dob.substring(0, 4));
//   const month = Number(dob.substring(4, 2)) - 1;
//   const day = Number(dob.substring(6, 2));

//   const today = new Date();
//   const age = today.getFullYear() - year;

//   if (
//     today.getMonth() < month ||
//     (today.getMonth() === month && today.getDate() < day)
//   ) {
//     age--;
//   }
// console.log('age',age)
//   return age;
// };

export const keysToRemove = [
  "menuStructure",
  "lastName",
  "auth",
  "loggedInUserId",
  "i18nextLng",
  "currentConsultantId",
  "userName",
  "firstName",
  "products",
];
export const showLogoWithBranches = ["Volksbank pur eG"];
export const loginPathNames = ["/login", "/admin/login"];
export const productId = "9432DEBC-37D8-444D-A4BF-DEBF7E6603CE";

export const filterCategories = (t) => [
  {
    category: "features",
    types: [
      {
        name: t("feature", {
          returnObjects: true,
        }).feature1,
        translationKey: "feature.feature1",
        value: false,
        type: "feature",
        key: "cl-family-tree",
      },
      {
        name: t("feature", {
          returnObjects: true,
        }).feature2,
        translationKey: "feature.feature2",
        value: false,
        type: "feature",
        key: "cl-assets",
      },
      {
        name: t("feature", {
          returnObjects: true,
        }).feature3,
        translationKey: "feature.feature3",
        value: false,
        type: "feature",
        key: "cl-your-wishes",
      },
      {
        name: t("feature", {
          returnObjects: true,
        }).feature4,
        translationKey: "feature.feature4",
        value: false,
        type: "feature",
        key: "cl-donations",
      },
      {
        name: t("feature", {
          returnObjects: true,
        }).feature5,
        translationKey: "feature.feature5",
        value: false,
        type: "feature",
        key: "cl-liquidity-plan",
      },
    ],
  },
  {
    category: "Format",
    types: [
      {
        name: t("format", {
          returnObjects: true,
        }).format1,
        translationKey: "format.format1",
        value: false,
        type: "format",
        key: "cl-upload",
      },
      {
        name: t("format", {
          returnObjects: true,
        }).format2,
        translationKey: "format.format2",
        value: false,
        type: "format",
        key: "cl-filling-form",
      },
    ],
  },
  {
    category: "Status",
    types: [
      {
        name: t("_status", {
          returnObjects: true,
        }).status1,
        translationKey: "_status.status1",
        value: false,
        type: "status",
        key: "checked",
      },
      {
        name: t("_status", {
          returnObjects: true,
        }).status2,
        translationKey: "_status.status2",
        value: false,
        type: "format",
        key: "unChecked",
      },
    ],
  },
];

export const EG_CONSULTANT = "#EC";

export const LANGUAGE = {
  de: "de",
  en: "en",
};
export const futurecatrFrontEndUrl = "https://www.futurecare.digital";
